import ApiClient from './ApiClient';

const apiClient = ApiClient('/customer_mapping');

export const upsertCustomerMapping = (craneId, payload, onSuccess, onError, onDone) => {
    apiClient.post(`/${craneId}/`, payload).then(onSuccess).catch(onError).finally(onDone);
};
